import { Component, Input, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ITaskComment, ITaskUserComment } from '../../../../../../../../../shared/interfaces/task.interface';
import { $taskComment } from '../../../../../../../../../shared/constants/task';
import { $comment, $manualAuditIssueComment } from '../../../../../../../../../shared/constants/comment';
import { ManualEvaluationAuditType } from '../../../../../../../../../shared/constants/manual-audit-issues';
import { IManualEvaluationAuditListItem } from '../../../../../../../../../shared/interfaces/manual-audit.interface';
import { IUserSmallItem } from '../../../../../../../../../shared/interfaces/user.interface';
import { LoadErrorHandler } from '../../../../../../../services/load-error-handler';
import { ProjectService } from '../../../../../../../services/project.service';

@Component({
  selector: 'app-linked-task-comments',
  templateUrl: './linked-task-comments.component.html',
  standalone: false,
})
export class LinkedTaskCommentsComponent implements OnInit {
  @Input() public workspaceId: string;
  @Input() public projectId: string;
  @Input() public taskId: string;

  public comments$: Observable<IManualEvaluationAuditListItem[]>;

  constructor(
    private projectService: ProjectService,
    private loadErrorHandler: LoadErrorHandler,
  ) {}

  public ngOnInit(): void {
    this.comments$ = this.projectService.getTaskComments(this.workspaceId, this.projectId, this.taskId).pipe(
      map((comments: ITaskComment[]): IManualEvaluationAuditListItem[] => comments.map(this.toFindingComment)),
      catchError((error: HttpErrorResponse): Observable<IManualEvaluationAuditListItem[]> => {
        this.loadErrorHandler.handleError('error_getting_documents', error, LinkedTaskCommentsComponent.name);
        return of([]);
      }),
    );
  }

  private toFindingComment = (comment: ITaskComment): IManualEvaluationAuditListItem => {
    const createdAt: Date | string | undefined = comment[$taskComment.createdAt];
    const updatedAt: Date | string | undefined = comment[$taskComment.updatedAt];

    return {
      [$comment._id]: comment[$taskComment._id],
      [$comment.type]: ManualEvaluationAuditType.manualAuditIssueComment,
      [$comment.user]: comment[$taskComment.author] as IUserSmallItem,
      [$comment.createdAt]: this.toIsoDateString(createdAt) ?? '',
      [$comment.updatedAt]: this.toIsoDateString(updatedAt),
      [$comment.edited]: (comment as ITaskUserComment)[$taskComment.edited],
      [$manualAuditIssueComment.message]: this.getCommentContent(comment) || undefined,
    };
  };

  private toIsoDateString(value: Date | string | undefined): string | undefined {
    if (value instanceof Date) {
      return value.toISOString();
    }
    if (value) {
      return String(value);
    }
    return undefined;
  }

  private getCommentContent(comment: ITaskComment): string {
    return 'commentType' in comment ? '' : ((comment as ITaskUserComment)[$taskComment.content] ?? '');
  }
}
